export const abreModalBuscaCameras = () => ({type: 'ABRE_MODAL_BUSCA_CAMERAS'});
export const fechaModalBuscaCameras = () => ({type: 'FECHA_MODAL_BUSCA_CAMERAS'});
export const changeFiltroCameras = (filtro) => ({ type: 'FILTRO_CAMERAS_CHANGED', filtro });
export const changeIncluiCamerasPublicas = (inclui) => ({ type: 'INCLUI_CAMERAS_PUBLICAS_CHANGED', inclui });



// WEBPACK FOOTER //
// ./src/actions/buscaCameras.js